import { createSelector } from 'reselect'

export const selectAuthToken = (state) => state.bootup.authToken
export const selectPremiumUpsellURL = (state) => state.bootup.premiumUpsellURL
export const selectPremiumStripeKey = (state) => state.bootup.premiumStripeKey
export const selectMapmyVersion = (state) => state.bootup.mapmyVersion
export const selectMessages = (state) => state.bootup.messages
export const selectLanguage = (state) => state.bootup.language
export const selectShouldRenderAds = (state) => state.bootup.shouldRenderAds

export const selectLanguageCode = createSelector(
  selectLanguage,
  (language) => language && language.code
)



// WEBPACK FOOTER //
// ./src/services/bootup/selectors.js